import React, { useEffect } from "react"
import style from "./reviews-birdeye.mod.scss"

const siteLanguage = process.env.GATSBY_LANGUAGE

const birdeyeConfig = {
  "en-AU": {
    scriptSrc:
      "https://getbirdeye.com.au/embed/v7/176420374302641/11/987654321301115183",
    widgetId: "bf-revz-widget-987654321301115183"
  },
  "en-NZ": {
    scriptSrc:
      "https://getbirdeye.com.au/embed/v7/176420444155440/11/987654321301115183",
    widgetId: "bf-revz-widget-987654321301115183"
  }
}

const ReviewsBirdeye = () => {
  const config = birdeyeConfig[siteLanguage] || birdeyeConfig["en-NZ"]
  useEffect(() => {
    // Use a small timeout to ensure DOM is ready and widget container exists
    const initBirdeye = () => {
      // Remove existing script if present to ensure clean re-initialization
      const existingScript = document.querySelector(
        `script[src='${config.scriptSrc}']`
      )
      if (existingScript) {
        existingScript.remove()
      }

      // Ensure widget container exists and is empty
      const widgetContainer = document.getElementById(config.widgetId)
      if (widgetContainer) {
        widgetContainer.innerHTML = ""
      }

      // Add the script fresh to trigger re-initialization
      const script = document.createElement("script")
      script.type = "text/javascript"
      script.src = config.scriptSrc
      script.async = true
      document.body.appendChild(script)
    }

    // Small delay to ensure DOM is ready, especially on client-side navigation
    const timeoutId = setTimeout(initBirdeye, 100)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [config.scriptSrc, config.widgetId])

  return (
    <div className={style.reviewsBirdeye}>
      <div className={style.reviewsBirdeye__widget}>
        <div id={config.widgetId} className={style.reviewsBirdeye__container} />
      </div>
      <p className={style.reviewsBirdeye__caption}>
        {"Birdeye is a trusted platform for customer reviews and ratings."}
      </p>
    </div>
  )
}

export default ReviewsBirdeye
